const theCostOfPoorQualityData = [
  {
    type: "paragraph",
    text: "Business success today is extremely data-driven. It is the right kind of data that enables marketers to analyse and understand their customer behaviours, market trends, and even their competitors. Therefore, maintaining data quality becomes vital for any marketing campaigner to ensure long-term success.",
  },
  {
    type: "paragraph",
    text: "As per Forrester's 2019 whitepaper 'Why Marketers Can't Ignore Data Quality', the very first thing that is extremely important for your marketing success is quality data. Everything, from your skills to executive support to even effective use of funds, comes after that.",
  },
  {
    type: "paragraph",
    text: "With that said, it is very important for any business to tap and harness the right quality from the quintillion bytes of data available at its disposal. For this, various MarTech solutions can be used, which can filter and extract the right data at the right time.",
  },
  {
    type: "paragraph",
    text: "But why is data quality so important, after all? What happens if one launches a marketing campaign with poor-quality data?",
  },
  {
    type: "paragraph",
    text: "Well, inadequate and poor data can not only incur unnecessary costs to your business, but also adversely impact your credibility. In the words of Albert Einstein, 'Not everything that can be counted counts and not everything that counts can be counted.'",
  },

  {
    type: "heading",
    text: "What Causes Poor-quality Data",
  },
  {
    type: "paragraph",
    text: "Poor-quality data may result from various factors, and some of them might even seem miniscule initially. Let's delve into a few important things, which can lead you to acquire poor quality data!",
  },

  {
    type: "list",
    items: [
      "Manual errors in data entry such as typos, duplicate entries, and/or missing entries can lead to poor-quality data.",
      "Inconsistency in the information fed can also lead you to fetch irrelevant or insufficient data at times. For instance, you might add The United Kingdom and UK at the same time and end up extracting incomplete data from the database for that location if you are not careful enough.",
      "Applying incorrect or inadequate filters on your marketing platform can lead to the extraction of bad-quality data, which may not be relevant for your campaign.",
    ],
  },

  {
    type: "heading",
    text: "The Impact of Poor-quality Data on Marketing Campaigns",
  },
  {
    type: "paragraph",
    text: "Irrespective of the reason for acquiring poor-quality data for your marketing campaigns, the cost your business has to bear is enormous. Here's what poor-quality data can lead to.",
  },

  {
    type: "list",
    items: [
      "Flawed Decision-making\nYour business decisions can only be as good as the data you base them on. So, if you don't have quality data required the fulfil the intent of marketing campaign, your final decision-making is bound to be flawed.",

      "Inefficiencies in Core Processes\nIf the core digital processes of your business depend on the marketing data you acquire, then obviously, bad-quality data will lead to major roadblocks in everything right from tapping potential leads to providing good user experience. And fixing these inefficiencies may put a great financial burden on your organisation too.",

      "Revenue Loss\nRevenue loss due to bad data can occur in multiple ways. For instance, incorrect customer data may translate into lost leads, unclear market segmentation info may lead to expensive marketing efforts without any results, and so on. Therefore, bad-quality data is detrimental to marketing financials.",

      "Dip in Conversion Rate\nInaccurate and/or misrepresented marketing data means you may reach out to people who don't find your product or service relevant to their requirement. This means you are not only spending money at the wrong place, but also reaching out to wrong audience who are never going to convert.",

      "Loss of Credibility\nPoor data quality may also cause you to lose credibility and trust with your customers. Imagine sending promotional emails about organic sugar to a diabetic person. How would such an email be treated? It would be trashed, right? And after that there would be rare chances that the customer would even open the promotional email from the same sender. Hence, not only analysis, but proper categorisation of data is also essential to make a marketing campaign fruitful.Today's world relies largely on data. Fetch the right data and it will not only give you the feel of what's in there, but also of what's not in there! So, whenever you are extracting data for any kind of marketing campaign, make sure it is based on the principle of ACUTE— Accuracy, Completeness, Uniqueness, Timeliness, and Effectiveness.",
    ],
  },
];

export default theCostOfPoorQualityData;
